
import { BrowserRouter } from 'react-router-dom';
import './App.css';
import Routing from './router/Routing';

function App() {
  return (
    <BrowserRouter>
      <Routing />
    </BrowserRouter>
  );
}

export default App;
